import { axiosInstance } from '@/lib/axios';
import { BusinessTripConfigurationModel } from './types';

type Props = {
  companyId: string
  payload: BusinessTripConfigurationModel
}

export function saveBusinessTripConfiguration({ companyId, payload }: Props) {
  return axiosInstance.post<any>(`/api/${companyId}/configuration/saveBusinessTripConfiguration`, payload);
}
